import React, { useContext, useState } from "react";
import { AppContext } from "./AppContext";

import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { WaypointWrapper } from "./WaypointWrapper";
import update from "immutability-helper";
import { Waypoint } from "./Waypoint";
import Search from "./Search";
import mapimg from "../img/examplemap.png";
import { formatDuration } from "../utils/human-readable-duration-format";
import { InfoTooltip } from "./Tooltip";
import { TOOLTIP_COPY } from "../utils/tooltips";

const ROUTES = ((window as any).rtnmap || {}).suggestedRoutes || [];

export const RouteTab: React.FC = () => {
  const {
    tourVenues,
    setTourVenues,
    addTourVenue,
    tourOrigin,
    // setTourOrigin,
    // tourDestination,
    // setTourDestination,
    route,
    isRouteStale,
    setRoute,
    calculateRoute,
    tourDates,
    setTourDates,
    setIsShareModalOpen,
    generateCSV,
    importHash,
  } = useContext(AppContext);

  const [isAddingCustomLocation, setIsAddingCustomLocation] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState<number>(1);

  const moveCard = (dragIndex: number, hoverIndex: number) => {
    const dragCard = tourVenues[dragIndex];
    setTourVenues(
      update(tourVenues, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragCard],
        ],
      })
    );
  };

  const deleteCard = (index: number) => {
    setTourVenues(
      update(tourVenues, {
        $splice: [[index, 1]],
      })
    );
  };

  const addTourDate = (venueId: string, date: string) => {
    // console.log({venueId, date})
    setTourDates({ ...tourDates, [venueId]: date });
  };

  const loadSuggestedRoute = (url: string) => {
    importHash(url.replace(/.*?#/, "#"));
    setExpandedPanel(1);
    setRoute(undefined);
  };

  return (
    <>
      <div className="title-block flex flex-col container-margin -mt-1">
        <button
          onClick={() => setExpandedPanel(expandedPanel === 0 ? 1 : 0)}
          className="text-left"
        >
          <div className="flex flex-row items-center py-4">
            <div className="flex-1">
              <h3 className="heading-3">
                Suggested Routes{" "}
                <InfoTooltip msg={TOOLTIP_COPY.suggestedRoutes} />
              </h3>
            </div>
            <div>
              <div className="text-xl">
                <i
                  className={`fal fa-chevron-up transition-all ${
                    expandedPanel === 0 ? "rotate-0" : "rotate-180"
                  }`}
                ></i>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div
        className={`${
          expandedPanel === 0
            ? "flex-grow h-full scrolling-touch overflow-y-auto opacity-100"
            : "flex-shrink h-0 overflow-hidden opacity-0"
        } transition-all your-route`}
      >
        {ROUTES.map((route: any, i: number) => (
          <div
            className="route bg-black container-margin my-2 mb-4 p-3 text-center shadow"
            key={i}
          >
            <div className="relative h-52 overflow-hidden">
              <img
                src={route.imageUrl || mapimg}
                className="w-full h-full absolute top-0 bottom-0 left-0 right-0 grayscale mix-blend-multiply z-10 object-cover"
                alt="Map"
              />
              <div className="bg-offwhite w-full-h-full absolute top-0 bottom-0 left-0 right-0" />
            </div>
            <div className="mb-3 mt-4 text-bold text-offwhite heading-2">
              {route.name}
            </div>
            <div className="mt-3 mb-4 text-offwhite paragraph">
              {route.description}
            </div>
            <div className="my-3 flex flex-row justify-center">
              <button
                className="block uppercase bg-offwhite text-black text-center button button-text py-1 px-3 mr-2"
                onClick={() => loadSuggestedRoute(route.url)}
              >
                Explore
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="title-block flex flex-col container-margin">
        <button
          onClick={() => setExpandedPanel(expandedPanel === 0 ? 1 : 0)}
          className="text-left"
        >
          <div className="flex flex-row items-center border-t border-black py-4">
            <div className="flex-1">
              <h3 className="heading-3">
                Your Route <InfoTooltip msg={TOOLTIP_COPY.yourRoute} />
              </h3>
            </div>
            <div className="text-xl">
              <div>
                <i
                  className={`fal fa-chevron-up transition-all ${
                    expandedPanel === 1 ? "rotate-0" : "rotate-180"
                  }`}
                ></i>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div
        className={`${
          expandedPanel === 1
            ? "flex-grow h-full scrolling-touch overflow-y-auto opacity-100"
            : "flex-shrink h-0 overflow-hidden opacity-0"
        } transition-all your-route`}
      >
        <div className="pt-4 paragraph">
          {/* {tourOrigin ?
                    <Waypoint
                        isDragging={false}
                        waypointKey={'A'}
                        waypointName={tourOrigin.properties.title}
                        waypointAddress={tourOrigin.properties.address}
                        stem={true}
                        nextLeg={!isRouteStale && tourOrigin ? route?.legs[0] : undefined}
                        onDeleteWaypoint={() => setTourOrigin(null)}
                    />  :
                    <Waypoint isDragging={false} waypointKey={'A'} stem={true} nextLeg={tourOrigin && !isRouteStale ? route?.legs[0] : undefined}>
                        <div className="relative mx-2">
                            <Search placeholder="Search for origin" onSelectPlace={(place: any) => {
                                setTourOrigin(place);
                            }} venues={[]} />
                        </div>
                    </Waypoint>
                } */}
          {tourVenues.length === 0 && !isAddingCustomLocation && (
            <Waypoint
              isDragging={false}
              waypointKey={""}
              waypointName={"Add a venue to start planning"}
              waypointAddress={
                "Click a venue on the map to add it to your route"
              }
              stem
            />
          )}
          <DndProvider backend={HTML5Backend}>
            {tourVenues.map((venue, i, arr) => (
              <WaypointWrapper
                key={venue.properties._path}
                index={i}
                id={venue.properties._path}
                moveCard={moveCard}
                waypointKey={`${i + 1}`}
                waypointName={venue.properties.title}
                waypointAddress={venue.properties.address}
                stem
                stemDashed={i === arr.length - 1}
                nextLeg={!isRouteStale && route?.legs[i + (tourOrigin ? 1 : 0)]}
                onDeleteWaypoint={() => deleteCard(i)}
                onSetTentativeDate={(v: string) => {
                  addTourDate(venue.properties._path, v);
                }}
                tentativeDate={tourDates[venue.properties._path] || ""}
              />
            ))}
          </DndProvider>
          {isAddingCustomLocation && (
            <Waypoint
              isDragging={false}
              waypointKey={""}
              onDeleteWaypoint={() => {
                setIsAddingCustomLocation(false);
              }}
            >
              <div className="relative mx-2">
                <Search
                  placeholder="Search location"
                  onSelectPlace={(place: any) => {
                    if (place) {
                      addTourVenue(place);
                      setIsAddingCustomLocation(false);
                    }
                  }}
                  venues={[]}
                />
              </div>
            </Waypoint>
          )}
          {/* {tourDestination ?
                    <Waypoint
                        isDragging={false}
                        waypointKey={'B'}
                        waypointName={tourDestination.properties.title}
                        waypointAddress={tourDestination.properties.address}
                        stem={false}
                        onDeleteWaypoint={() => setTourDestination(null)}
                    /> :
                    <Waypoint isDragging={false} waypointKey={'B'}>
                        <div className="relative mx-2">
                            <Search placeholder="Search for destination" onSelectPlace={(place: any) => {
                                setTourDestination(place);
                            }} venues={[]} />
                        </div>
                    </Waypoint>
                } */}

          {!isAddingCustomLocation && (
            <div className={"flex flex-row"}>
              <div className="w-20 py-2"></div>
              <button
                onClick={() => setIsAddingCustomLocation(true)}
                className={"flex-1 flex flex-row items-center text-left"}
              >
                <div className="w-10 h-10 text-black text-2xl font-bold flex items-center justify-center rounded-full border border-black">
                  <div>
                    <i className="fal fa-plus mt-1" />
                  </div>
                </div>
                <div className="flex-1">
                  <div className="px-2 paragraph">
                    <div className="font-bold">Search location</div>
                  </div>
                </div>
              </button>
            </div>
          )}
        </div>

        <div className={"flex flex-row my-8 paragraph"}>
          <div className="w-20 py-2"></div>
          <div className="w-10"></div>
          <div className={"flex-1 flex flex-row items-center text-left"}>
            <div className="px-2">
              Total:{" "}
              {!route
                ? "Calculate route to see total"
                : isRouteStale
                ? "Recalculate route to see total"
                : `${formatDuration(route.duration)}, ${Math.round(
                    route.distance / 1000
                  ).toLocaleString()}km`}
            </div>
          </div>
        </div>
        <div
          className={
            "flex flex-row mt-6 mb-4 paragraph container-margin calculate-button"
          }
        >
          <div className={"flex-1 flex flex-row items-center text-left"}>
            <button
              className={
                "block flex-1 bg-black text-offwhite button button-text " +
                (isRouteStale || !route
                  ? "bg-black text-offwhite fill-offwhite"
                  : "bg-transparent text-black fill-black border border-black")
              }
              onClick={() => {
                if (isRouteStale || !route) {
                  calculateRoute();
                }
              }}
              disabled={!(isRouteStale || !route)}
            >
              {!(isRouteStale || !route)
                ? "Route calculated"
                : route && isRouteStale
                ? "Re-calculate route "
                : "Calculate route"}{" "}
              <svg
                width="14px"
                className="ml-1 -mt-1 inline-block"
                viewBox="0 0 18 15.75"
              >
                <g>
                  <path d="M11.22,11.25l3.38-4.5,3.4,4.5H15.75v1.13a3.37,3.37,0,0,1-3.37,3.37H5.62a3.37,3.37,0,0,1-3.37-3.37V11.25H4.5v1.13A1.13,1.13,0,0,0,5.62,13.5h6.76a1.13,1.13,0,0,0,1.12-1.12V11.25Z" />
                  <path d="M6.78,4.5,3.4,9,0,4.5H2.25V3.38A3.37,3.37,0,0,1,5.62,0h6.76a3.37,3.37,0,0,1,3.37,3.38V4.5H13.5V3.38a1.13,1.13,0,0,0-1.12-1.13H5.62A1.13,1.13,0,0,0,4.5,3.38V4.5Z" />
                </g>
              </svg>
            </button>
          </div>
        </div>
        {/* <Waypoint isDragging={false} waypointKey={'B'} waypointName={'Destination'} waypointAddress={'Unspecified'} /> */}
        {/* <Search placeholder="Search custom location" onSelectPlace={(place: any) => {
                if(place){
                    addTourVenue(place);
                }
            }} venues={[]} /> */}
      </div>
      <div
        className={`${
          expandedPanel === 1
            ? "opacity-100"
            : "flex-shrink h-0 overflow-hidden opacity-0"
        } transition-all container-margin`}
      >
        <div className="py-4 flex flex-grow flex-col border-t border-black">
          <div className="flex flex-row">
            <button
              className="block flex-1 bg-black text-offwhite button button-text mr-4"
              onClick={() => generateCSV()}
            >
              Download{" "}
              <svg
                width="13px"
                className="ml-1 -mt-1 inline-block fill-offwhite"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 15 15"
              >
                <path d="M5.62,0H9.38V5.62h1.89L7.5,11.25C6.24,9.38,5,7.51,3.75,5.62H5.62Z" />
                <path d="M13.13,13.11V9.38H15V15H0V9.38H1.85v3.73Z" />
              </svg>
            </button>

            <button
              className="block flex-1 bg-black text-offwhite button button-text"
              onClick={() => setIsShareModalOpen(true)}
            >
              Save / Share{" "}
              <svg
                width="15px"
                className="ml-1 -mt-1 inline-block fill-offwhite"
                viewBox="0 0 15 11.79"
              >
                <path d="M15,4.52,9.23,0V2.16C7.22,2.35,0,3.58,0,11.79c0,0,1.74-5.17,9.23-5.36V9Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* <div className="m-2 flex-grow flex flex-col">
            <div className="flex flex-row">
                <div className="flex-1">
                    <h3 className="text-2xl font-bold">Your Route</h3>
                </div>
                <div className="text-xl">
                    <button><i className="fal fa-chevron-down"></i></button>
                </div>
            </div>
        </div> */}
      {/* scrolling-touch overflow-y-auto */}
    </>
  );
};
